export default {
  title: 'Urmărește comanda',
  text: 'Îți mulțumim că ai comandat! Parteneriatul nostru cu <0>{{carrier}}</0> ne permite să gestionăm livrările direct pe site, economisind în medie {{savings}} în comisioane de livrare. Comanda ta va fi livrată de <1>{{carrier}}</1>, asigurând un serviciu excelent 😊',
  labels: {
    delivered_by: 'Livrat de',
  },
  buttons: {
    track_order: 'Urmărește comanda în timp real →',
    track_order_once_confirmed: 'Urmărește comanda în timp real după confirmare',
  },
};
